import { gql } from '@apollo/client';

export const AI_CREATE_PROMPT_REPORT = gql`
    mutation CreatePromptReport( $input: CreatePromptReportInput! ) {
        promptReport: createPromptReport( input: $input ) {
            id
            companyId
            promptId
            csvObjectKey
            graphObjectKey
            rawData
            numRows
            createdAt
            graphSignedUrl
            csvSignedUrl
        }
    }
`;

export default AI_CREATE_PROMPT_REPORT;
